import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import realMachinesLogo from '@/assets/branding/real-maquinas-logo-transparent.png'
import {
  BackupStatusIndicator,
  BackupReminderBanner,
  BottomNavigation,
  OfflineIndicator,
  StoragePersistenceIndicator,
} from '@/components'
import { paths } from '@/routes/paths'

function currentPageLabel(pathname: string) {
  if (pathname === paths.reports) return 'Relatórios'
  if (pathname === paths.newReport) return 'Novo relatório'
  if (pathname.includes('/inspecao')) return 'Checklist da inspeção'
  if (pathname.includes('/resumo')) return 'Resumo do relatório'
  if (pathname.startsWith('/relatorios/')) return 'Detalhes do relatório'
  if (pathname === paths.clients) return 'Clientes'
  if (pathname === paths.newClient) return 'Novo cliente'
  if (pathname.startsWith('/clientes/') && pathname.endsWith('/editar')) return 'Editar cliente'
  if (pathname.startsWith('/clientes/')) return 'Detalhes do cliente'
  if (pathname === paths.machines) return 'Máquinas'
  if (pathname === paths.newMachine) return 'Nova máquina'
  if (pathname.startsWith('/maquinas/') && pathname.endsWith('/editar')) return 'Editar máquina'
  if (pathname.startsWith('/maquinas/')) return 'Detalhes da máquina'
  if (pathname === paths.technicians) return 'Técnicos'
  if (pathname === paths.newTechnician) return 'Novo técnico'
  if (pathname.startsWith('/tecnicos/') && pathname.endsWith('/editar')) return 'Editar técnico'
  if (pathname.startsWith('/tecnicos/')) return 'Detalhes do técnico'
  if (pathname === paths.backup) return 'Backup'
  if (pathname === paths.settings) return 'Configurações'
  return 'Página'
}

export function AppLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const isHome = location.pathname === paths.home

  const goBack = () => {
    const state = window.history.state as { idx?: number } | null
    if ((state?.idx ?? 0) > 0) {
      void navigate(-1)
      return
    }
    void navigate(paths.home)
  }

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Ir para o conteúdo
      </a>
      <header className="brand-bar">
        <span className="brand-bar__balance" aria-hidden="true" />
        <Link className="brand-bar__identity" to={paths.home} aria-label="Real Máquinas — início">
          <img
            src={realMachinesLogo}
            alt="Real Máquinas — Mecânica especializada em máquinas pesadas"
            width="1636"
            height="1252"
          />
        </Link>
        <div className="brand-bar__statuses" aria-label="Situação do aplicativo">
          <OfflineIndicator />
          <StoragePersistenceIndicator />
          <BackupStatusIndicator />
        </div>
      </header>
      <BackupReminderBanner />
      <main className="app-content" id="main-content">
        {!isHome ? (
          <nav className="context-navigation" aria-label="Navegação contextual">
            <button className="back-button" type="button" onClick={goBack}>
              <span aria-hidden="true">←</span>
              Voltar
            </button>
            <ol className="breadcrumb">
              <li>
                <Link to={paths.home}>Início</Link>
              </li>
              <li aria-current="page">{currentPageLabel(location.pathname)}</li>
            </ol>
          </nav>
        ) : null}
        <Outlet />
      </main>
      <BottomNavigation />
    </div>
  )
}
